export default "__VITE_ASSET__2Ywoo3$2__"